export enum YettelAdminTypeIds {
  ADMINISTRATOR = '5c3bb225-025d-4773-b11e-d9e12a18c8b2',
  MODERATOR = 'f84c564a-b1ef-44c4-9701-9cffaa65bafd',
  SELLER = 'e5f74f77-015c-49fd-a05a-bd7200aefe91',
}
